import React from 'react';
import {useI18n} from '../../../../../data/hooks/i18nHooks';
import {useParticipantsCategories} from '../../../../../data/hooks/participant/useParticipantsCategories';
import {useRecommendedParticipantsFilter} from '../../../../../data/hooks/participant/useRecommendedParticipantsFilter';
import styles from './FilterHint.module.scss';
import {isFilterHintVisible} from './isFilterHintVisible';

function FilterHint(props) {
    const {eventId, filterParams} = props,
        categories = useParticipantsCategories(eventId),
        suggestedFilterParams = useRecommendedParticipantsFilter(eventId),
        i18n = useI18n();

    if (!isFilterHintVisible(filterParams, suggestedFilterParams, categories)) return null;

    return (
        <div className={styles.FilterHint}>
            {i18n['hint.tab.suggest_filter']}
            <div className={styles.clickHere} />
        </div>
    );
}

export default FilterHint;
